module.exports = __webpack_public_path__ + "bd560e35bfb37f1f96082ddbc0743128.jpg";